import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { AuditDashboardInputDTO } from 'app/model/auditor-dashboard-input-dto';
import { CommonDTO } from '../model/common-dto';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { UrlConfigService } from './url-config.service';

@Injectable({
  providedIn: 'root'
})
export class DownloadReportService {


  // url = environment.SERVER_URL;
  token = '';
  TOKEN = "token";

  url: string;
  constructor(private http: HttpClient, private urlConfigService: UrlConfigService) {
    this.url = this.urlConfigService.apiServerUrl;
  }

  downloadPdfReport(commonDTO: CommonDTO) {

    let authKey;
    authKey = localStorage.getItem(this.token);
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        'Authorization': authKey,
      })
    };

    return this.http.post(`${this.url}report/download-pdf-report`, commonDTO, httpOptions);
  }
  downloadDocReport(commonDTO: CommonDTO) {
    let authKey;
    authKey = localStorage.getItem(this.token);
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        'Authorization': authKey,
      })
    };

    return this.http.post(`${this.url}report/download-doc-report`, commonDTO, httpOptions);
  }

  downloadItemWiseReport(commonDTO: CommonDTO) {
    let authKey;
    authKey = localStorage.getItem(this.token);
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        'Authorization': authKey,
      })
    };

    return this.http.post(`${this.url}report/download-doc-report`, commonDTO, httpOptions);
  }
  downloadDeptWiseReport(commonDTO: CommonDTO) {
    let authKey;
    authKey = localStorage.getItem(this.token);
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        'Authorization': authKey,
      })
    };

    return this.http.post(`${this.url}report/downloadDeptWiseReport`, commonDTO, httpOptions);
  }

  downloadDocReportScopeIdsWise(commonDTO: CommonDTO) {
    let authKey;
    authKey = localStorage.getItem(this.token);
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        'Authorization': authKey,
      })
    };

    return this.http.post(`${this.url}report/download-item-wise-report`, commonDTO, httpOptions);
  }

}


